import request from '@/router/axios';

export const uploadExcelFile1 = (formData) => {
  return request({
    url: '/api/baseImport/uploadExcelDept',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};
export const uploadExcelFile2 = (formData) => {
  return request({
    url: '/api/baseImport/uploadExcelUser',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const uploadExcelFile3 = (formData) => {
  return request({
    url: '/api/baseImport/uploadExcelConsumable',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const uploadExcelFile4 = (formData) => {
  return request({
    url: '/api/baseImport/uploadExcelArea',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const uploadExcelFile5 = (formData) => {
  return request({
    url: '/api/baseImport/uploadExcelServiceItem',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

//新增设备记录
export const initializeData = (params, options) =>
  request.post('/api/baseImport/initializeData', params,options)
